import { render, staticRenderFns } from "./_BackgroundPreview.vue?vue&type=template&id=4952aa4c&scoped=true&"
import script from "./_BackgroundPreview.vue?vue&type=script&lang=ts&"
export * from "./_BackgroundPreview.vue?vue&type=script&lang=ts&"
import style0 from "./_BackgroundPreview.vue?vue&type=style&index=0&id=4952aa4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4952aa4c",
  null
  
)

export default component.exports